import clsx from 'clsx';
import { ProductCategory } from '../accessExpress.types';

interface GlowingBorderProps {
  category?: ProductCategory;
  borderWidth?: number;
  borderRadius?: number;
  className?: string;
}

const GlowingBorder = ({
  category,
  borderWidth = 2,
  borderRadius = 4,
  className,
}: GlowingBorderProps) => {
  return (
    <>
      {/* Glow Effect */}
      <div
        className={clsx(
          'pointer-events-none absolute inset-0 -z-10',
          className,
        )}
        style={{
          opacity: 0.24,
          background:
            // TODO: fix
            category === 'Starlink'
              ? ''
              : 'linear-gradient(134deg, #7E77B3 0%, #8989FF 25%, #6C9DFF 50%, #78CFDA 75%, #9FF4A9 100%)',
          filter: 'blur(16px)',
        }}
      />

      {/* Gradient Border */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'linear-gradient(134deg, #7E77B3, #8989FF, #6C9DFF, #78CFDA, #9FF4A9)',
          WebkitMask:
            'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
          borderRadius: `${borderRadius}px`,
          padding: `${borderWidth}px`,
        }}
      />
    </>
  );
};

export default GlowingBorder;
